import React, { Fragment, useEffect, useRef, useState } from 'react';
import {
  addQueryParamWithoutRedirecting,
  assemble,
  createFiltersFromRedirect,
  formatDateLang,
  formatFilters,
  isItUndefined,
} from '../../util/DataUtil';
import ResourceFilter from '../resources/resource-filter';
import { getLanguage, useWindowSize } from '../../util/PageUtil';
import { useRouter } from 'next/router';
import { getBackendUrl } from '../../util/Constants';
import { CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';
import { setLocalStorageRedux } from '../../store/localStorageSlice';
import Select from 'react-select';
import Image from 'next/image';

const LatestArticles = ({
  lang,
  global,
  topics,
  data,
  contentType,
  nodeId,
  contentTags,
}) => {
  const router = useRouter();
  const windowSize = useWindowSize();
  const [query, setQuery] = useState([]);
  const [page, setPage] = useState(0);
  const [facetFilters, setFacetFilters] = useState([]);
  const [languageFilter, setLanguageFilter] = useState([]);
  const [results, setResults] = useState(false);
  const [applyFilter, setApplyFilter] = useState(false);
  const [filterProps, setFilterProps] = useState([]);
  const [showMore, setShowMore] = useState([]);
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [closeFilters, setCloseFilters] = useState(false);
  const [author, setAuthor] = useState('');
  const [topicsAndAuthors, setTopicsAndAuthors] = useState([]);
  const [currentPageData, setCurrentPageData] = useState([]);
  // const [contentTagSelection, setContentTagSelection] = useState([]);
  const [authors, setAuthors] = useState([]);
  const controller = useRef(null);
  const authorsTopicId = topics?.find((t) => t.name === 'Authors')?.id || '0';

  useEffect(() => {
    return () => {
      if (controller.current) {
        controller.current.abort();
      }
    };
  }, []);

  const manuallyAddedArticles = data.field_manually_added_articles;

  const myLocalStorage = useSelector(setLocalStorageRedux);

  const isAuthorContentType = contentType === 'author';

  const hitsPerPage = 9;

  let lng =
    typeof window !== 'undefined' ? getLanguage(window.location.hostname) : '';

  if (typeof window !== 'undefined') {
    var backendUrl = getBackendUrl(window.location.host)?.remoteServer;
  }

  const sortByOptions = [
    {
      value: 'recent',
      label: data.field_most_recent_text?.[0]?.value || 'Recent',
    },
    {
      value: 'popular',
      label: data.field_most_popular_text?.[0]?.value || 'Popular',
    },
    { value: 'az', label: data.field_a_z_text?.[0]?.value || 'A-Z' },
    { value: 'za', label: data.field_z_a_text?.[0]?.value || 'Z-A' },
  ];
  const [sortBySelectedOption, setSortBySelectedOption] = useState('recent');

  useEffect(() => {
    if (!lng) {
      return;
    }
    setIsLoading(true);

    if (isAuthorContentType) {
      setAuthor(nodeId);
    }
    fetchArticlesData();
    // }, [applyFilter, query, sortBySelectedOption, page, author, filterProps]);
  }, [applyFilter, sortBySelectedOption, page, author, filterProps]);

  useEffect(() => {
    fetchAuthorsData();
  }, []);

  const triggerFilterFromRedirect = (routeFilter) => {
    // let filters = createFiltersFromRedirect(filter, topicsAndAuthors);
    const { url, url1, ...cleanFilter } = routeFilter;

    const topicFilters = createFiltersFromRedirect(cleanFilter, topics);
    const tagFilters = createFiltersFromRedirect(cleanFilter, contentTags);
    tagFilters.forEach((tag) => {
      tag.tid = tag.id;
    });
    const authorFilters = createFiltersFromRedirect(cleanFilter, authors);

    const filters = [...topicFilters, ...tagFilters, ...authorFilters];

    triggerFilter(filters);
    setApplyFilter(true);
  };

  const triggerFilter = (filters) => {
    setFilterProps(filters);

    let searchFilters = [];
    for (let filter of filters) {
      searchFilters.push(filter?.id);
    }

    setFacetFilters(searchFilters);
    setPage(0);
    setApplyFilter(false);
  };

  useEffect(() => {
    let localFilter = router.query;

    if (typeof window !== 'undefined') {
      hasNonEmptyProperties(localFilter)
        ? triggerFilterFromRedirect(localFilter)
        : clearAll();
    }
  }, [myLocalStorage, authors]);

  function hasNonEmptyProperties(obj) {
    for (const key in obj) {
      if (
        !key.startsWith('url') &&
        obj[key] !== null &&
        obj[key] !== undefined &&
        obj[key] !== ''
      ) {
        return true;
      }
    }
    return false;
  }
  const fetchAuthorsData = () => {
    let url = backendUrl + 'authors?' + 'langcode=' + lng + '&filter=az&from=0';

    const fetchAuthors = async () => {
      try {
        const response = await fetch(url);
        const authorsResponse = await response.json();

        const filteredAuthors = authorsResponse
          .filter(
            (author) => author.field_exclude_from_filter?.[0]?.value !== '1'
          )
          .map((author, i) => ({
            id: author.node_id,
            name: author.field_author_full_name?.[0]?.value,
            parent_id: authorsTopicId,
            description: 'Author',
            weight: i + 1,
            field_source_translation: author.field_author_full_name?.[0]?.value,
          }));

        const updatedTopics = [...topics, ...filteredAuthors];

        setTopicsAndAuthors(updatedTopics);
        setAuthors(filteredAuthors);
      } catch (error) {
        console.error('Error fetching Authors data:', error);
      }
    };
    fetchAuthors();
  };

  useEffect(() => {
    if (query === undefined) return; //ili <3 slova
    const delayDebounce = setTimeout(() => {
      fetchArticlesData();
      setIsLoading(true);
    }, 300);

    return () => clearTimeout(delayDebounce);
  }, [query]);
  // }, [query, facetFilters, languageFilter, sortBySelectedOption, page]);

  const fetchArticlesData = () => {
    if (controller.current) {
      controller.current.abort();
    }
    controller.current = new AbortController();
    setResults(
      (query.length || facetFilters.length || languageFilter.length) !== 0
    );

    let hits = hitsPerPage;
    if (page == 0 && facetFilters.length == 0) {
      hits = hitsPerPage - manuallyAddedArticles.length;
    }

    const topicIds = filterProps
      .filter((item) => item.description !== 'Author' && !item.tid) //tid is tag id
      .map((item) => item.id);
    const topicIdsString = topicIds.join(',');

    const currentTagIds = filterProps.map((filter) => filter.tid);

    // const tagIdsString = currentTagIds.join(',');
    const tagIdsString = currentTagIds
      .filter((id) => id != null && id !== undefined && id !== '')
      .join(',');

    const authorIds = filterProps
      .filter((item) => item.description === 'Author')
      .map((item) => item.id);

    let authorIdsString = '';
    if (author) {
      authorIdsString = author;
    } else {
      authorIdsString = authorIds.join(',');
    }

    let url =
      backendUrl +
      'articles?' +
      'langcode=' +
      lng +
      '&filter=' +
      sortBySelectedOption +
      '&from=' +
      page * hits +
      '&count=' +
      hits +
      '&topics=' +
      topicIdsString +
      '&author=' +
      authorIdsString +
      '&search=' +
      query +
      '&tags=' +
      tagIdsString;

    const fetchArticles = async () => {
      try {
        const response = await fetch(url, {
          signal: controller.current.signal,
        });
        const newResponse = await response.json();

        if (page == 0) {
          //TODO: manuallyAddedArticles
          setShowMore([...manuallyAddedArticles, ...newResponse]);
          setCurrentPageData([...manuallyAddedArticles, ...newResponse]);
        } else {
          setShowMore([...showMore, ...newResponse]);
          setCurrentPageData(newResponse);
        }

        setTimeout(() => {
          setIsLoading(false);
        }, 100);
      } catch (error) {
        console.error('Error fetching Articles data:', error);
      }
    };
    fetchArticles();
  };

  const handleSearch = (search) => {
    setQuery(search.length !== 0 ? [search] : []);
    setPage(0);
    setApplyFilter(false);
  };

  const clearAll = () => {
    setFilterProps([]);
    triggerFilter([]);
    setLanguageFilter([]);
    if (query.length > 0) {
      setQuery([]);
    }
    setShowMore([]);
    setCloseFilters(false);
  };

  const clearQuery = () => {
    setQuery([]);
    setIsSearchActive(false);
    setIsFilterActive(true);
  };

  const renderBlogInfo = (blogItem) => {
    const authors = blogItem?.field_authors || [];
    const authorNames =
      authors
        ?.map((a) => a?.field_author_full_name?.[0]?.value)
        .filter(Boolean)
        .join(', ') || null;
    const publishDate = isItUndefined(blogItem?.field_publish_date) || null;
    const timeToRead = isItUndefined(blogItem?.field_time_to_read) || null;
    return (
      <div className={'blog-info'}>
        <span className={'author-name'}>
          {authorNames ? `${authorNames}` : ''}
        </span>

        {authors.length > 1 && <br />}
        {authors.length === 1 && publishDate ? (
          <span className={'separator'}>{' | '}</span>
        ) : null}
        <span className={'publish-date'}>
          {publishDate ? formatDateLang(publishDate) : ''}
        </span>
        {(authorNames || publishDate) && timeToRead ? (
          <span className={'separator'}>{' | '}</span>
        ) : null}
        <span className={'blog-read-time'}>{timeToRead ? timeToRead : ''}</span>
      </div>
    );
  };

  const handleChipClick = (event, filter) => {
    event.preventDefault();
    event.stopPropagation();

    if (isAuthorContentType) {
      router.push({
        pathname: '/resources/articles',
        query: { contentTag: filter.name.toLowerCase() },
        hash: 'articles-cards-container',
      });
      // } else if (!contentTagSelection.includes(filter.tid)) {
    } else if (!filterProps.some((item) => item.tid === filter.tid)) {
      setFilterProps([...filterProps, filter]);
      router.push({
        pathname: router.asPath,
        // query: { ...router.query, contentTag: filter.name.toLowerCase() },
        hash: 'articles-cards-container',
      }, undefined, { shallow: true });
      // setContentTagSelection([...contentTagSelection, filter.tid]);
      setPage(0);
    }
  };

  const renderPills = (blogItem, smallItems = false) => {
    const limit = smallItems ? 2 : 3;
    return (
      <div className={'blog-pills'}>
        <span
          className={`blog-pill`}
          onClick={(event) =>
            handleChipClick(event, blogItem?.field_template_category?.[0])
          }
        >
          {blogItem?.field_template_category?.[0]?.name}
        </span>
        {blogItem?.field_template_secondary_categor
          ?.slice(0, limit - 1)
          ?.map((item, index) => (
            <span
              className={`blog-pill`}
              onClick={(event) => handleChipClick(event, item)}
            >
              {item.name}
            </span>
          ))}
      </div>
    );
  };

  const getTitle = (item) => {
    if (item?.field_display_title?.[0]?.value) {
      return item?.field_display_title?.[0]?.value;
    }

    const templateBlocks = item.field_template_blocks;
    let titleBlock = null;

    if (Array.isArray(templateBlocks)) {
      titleBlock =
        templateBlocks.find((block) => block.template_title_block_type)
          ?.template_title_block_type || null;
    } else if (templateBlocks?.template_title_block_type) {
      titleBlock = templateBlocks?.template_title_block_type;
    }
    if (titleBlock?.field_template_title?.[0]?.value) {
      return titleBlock.field_template_title?.[0]?.value;
    }
    return item?.title;
  };

  const renderBannerImage = (item) => {
    const templateBlocks = item.field_template_blocks;
    let bannerBlock = null;

    if (Array.isArray(templateBlocks)) {
      bannerBlock =
        templateBlocks.find((block) => block.template_banner_block_type)
          ?.template_banner_block_type || null;
    }

    if (templateBlocks?.template_banner_block_type) {
      bannerBlock = templateBlocks?.template_banner_block_type;
    }

    const bannerImage =
      bannerBlock?.field_web_small_image?.webimage ??
      bannerBlock?.field_template_banner_bynder?.webimage ??
      null;

    const validSrc =
      bannerImage && bannerImage.trim() !== ''
        ? bannerImage
        : '/images/placeholder.png';

    if (bannerImage) {
      return (
        <Image
          layout="fill"
          alt="search-image"
          src={validSrc}
          priority
          sizes="(max-width: 768px) 100vw, 33vw"
        />
      );
    }
    return (
      <Image layout="fill" alt="search-image" src={'/images/placeholder.png'} />
    );
  };

  const renderSearchCards = (data, length = -1) => {
    let result = [];

    if (!data) {
      return;
    }

    for (let item of data) {
      result.push(
        <a
          className={'search-card'}
          href={item?.['url-alias']?.length ? item['url-alias'] : '/'}
          onClick={(event) => {
            if (event.target.closest('.second-category')) {
              event.preventDefault();
            }
          }}
        >
          <div className={'image-title'}>
            <div className={'img-container'}>{renderBannerImage(item)}</div>
            <div className={'title'}>{getTitle(item)}</div>
          </div>
          <div className={'card-text-container'}>
            {renderBlogInfo(item)}
            {renderPills(item)}
          </div>
        </a>
      );
    }
    return result;
  };

  function renderSearchResults(data, global) {
    if (!data) {
      return;
    }

    if (data.length === 0) {
      return (
        <div className={'no-result'}>
          <h2>
            {global?.field_no_results_text?.[0]?.value ||
              'No results were found. Please check the spelling, reset any filters and try again.'}
          </h2>
          <div
            className={'clear-all'}
            onClick={() => {
              clearAll();
            }}
          >
            {global?.field_clear_all_label?.[0]?.value ||
              'Clear all search terms.'}
          </div>
        </div>
      );
    }
    return renderSearchCards(showMore);
  }

  const handleSortOptionChange = (option) => {
    setSortBySelectedOption(option.value);
    setPage(0);
    setApplyFilter(true);
  };

  const renderSortByDropDown = () => {
    return (
      <div className="sort-by">
        <label
          htmlFor="select"
          id="label"
          style={{ width: '100px', zIndex: '1' }}
        >
          {data?.field_sort_by_text?.[0]?.value || 'Sort By'}
        </label>
        <Select
          id="select"
          aria-labelledby="label"
          defaultValue={sortByOptions[0]}
          options={sortByOptions}
          onChange={(selectedOption) => handleSortOptionChange(selectedOption)}
        ></Select>
      </div>
    );
  };

  return (
    <div id="articles-cards-container" className="latest-articles">
      {!isAuthorContentType ? (
        <ResourceFilter
          singleFilter={true}
          clearQuery={clearQuery}
          isSearchActive={isSearchActive}
          isFilterActive={isFilterActive}
          setIsSearchActive={setIsSearchActive}
          setIsFilterActive={setIsFilterActive}
          search={
            data.field_search_articles_text?.[0]?.value ||
            isItUndefined(global.field_search_text_translation)
          }
          filterProps={filterProps}
          triggerFilter={triggerFilter}
          data={assemble(topicsAndAuthors)}
          onSearchChange={handleSearch}
          handleFilterApply={setApplyFilter}
          searchQuery={query}
          setQuery={setQuery}
          languageFilter={languageFilter}
          setLanguageFilter={setLanguageFilter}
          screenWidth={windowSize.width}
          clearAll={clearAll}
          title={
            data.field_filter_articles_text?.[0]?.value ||
            isItUndefined(global.field_filter_text)
          }
          cancelText={isItUndefined(global.field_cancel_text_translation)}
          applyFilterText={isItUndefined(global.field_apply_filters_text)}
          clearAllText={isItUndefined(global.field_clear_all_text)}
          selectedText={isItUndefined(global.field_selected_text)}
          seeMoreText={isItUndefined(global?.field_see_more_text)}
          seeLessText={isItUndefined(global?.field_see_less)}
          isPartnerPage={false}
          showAdvancedFilterButtons={false}
          alwaysDarkFilter={true}
        />
      ) : null}

      {/*{!isLoading ? (*/}
      {/*    algoliaData.nbHits != 0 ? (*/}
      <div className={'search-results-header-latest-articles inner-container'}>
        <div className={'results-text'}>
          <div>
            {filterProps.length === 0
              ? data.field_latest_articles_title?.[0]?.value ||
                'Latest Articles'
              : data.field_results_text?.[0]?.value || 'Results'}
          </div>
          {renderSortByDropDown()}
        </div>

        <div className={'horizontal-line'} />
        {isLoading && page == 0 ? (
          <div className={'loader'}>
            <CircularProgress />
          </div>
        ) : (
          <Fragment>
            <div className={'search-results'}>
              {renderSearchResults(showMore, global, data)}
            </div>
            {/*{algoliaData.page + 1 !== algoliaData.nbPages &&*/}
            {/*  algoliaData.nbHits !== 0 && (*/}
            {isLoading ? (
              <div className={'loader'}>
                <CircularProgress />
              </div>
            ) : currentPageData.length < hitsPerPage ? null : (
              <div className={'show-more'} onClick={() => setPage(page + 1)}>
                Show More
              </div>
            )}
          </Fragment>
        )}
      </div>
    </div>
  );
};
export default LatestArticles;
